import { AccountCircle } from '@mui/icons-material';
import { Avatar, Typography } from '@mui/material';
import { EasTooltip } from '../EasTooltip';
import { FC, SyntheticEvent } from 'react';
import { TUser } from 'redux/reducers/user/types';
import { stringAvatar, stringToColor } from 'utils/stringAvatar';
import { COLORS } from '../../services/constants/colors';
import { useSelector } from 'react-redux';
import { getUserInfo } from '../../redux/reducers/user/selectors';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../routes/constants';

export type TUserAvatarProps = {
	user: TUser | null;
	size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | undefined;
	onClick?: (e: SyntheticEvent) => void;
	tooltip?: boolean;
};
export const UserAvatar: FC<TUserAvatarProps> = ({
	user,
	onClick,
	size = 'sm',
	tooltip = true,
}) => {
	const navigate = useNavigate();
	const newUserNameLC = user?.fullName?.trim()?.split?.(' ')?.[0]?.toLowerCase() ?? '';
	const newUserNameUc = `${newUserNameLC?.[0]?.toUpperCase()}${newUserNameLC?.slice(1)}`;
	const newUserName = user?.fullName === 'Unknown user' || !user?.fullName ? '' : newUserNameUc;
	const handleOnClick = (e: SyntheticEvent) => {
		if (onClick) {
			onClick(e);
		} else if (isAdmin) {
			navigate(`${PATHS.USER_MANAGEMENT_PAGE}?userId=${user?.id}`);
		}
		// e.stopPropagation();
	};
	const userInfo = useSelector(getUserInfo);

	const isAdmin = userInfo?.roles?.some((role) => role.roleName === 'admin');

	return (
		<EasTooltip
			title={
				tooltip ? (
					<div>
						{user?.email}
						<br />
						{isAdmin ? <i>click to view user details</i> : ''}
					</div>
				) : undefined
			}
		>
			<Typography
				// ref={refnewUserNameFilter}
				component="button"
				type="button"
				sx={{
					fontWeight: 'bold',
					// color: 'primary.main',
					// color: '#fff',

					color: COLORS.font_status,
					fontSize:
						size === 'xxs'
							? '.7rem'
							: size === 'xs'
								? '.8rem'
								: size === 'sm'
									? '1rem'
									: size === 'md'
										? 20
										: 48,
					display: 'flex',
					alignItems: 'center',
					gap: '3px',
					cursor: onClick || isAdmin ? 'pointer' : 'default',
					borderRadius: '20px',
					padding: '2px 8px 2px 2px',
					backgroundColor: newUserName === '' ? COLORS.SECONDARY : stringToColor(newUserName),
					border: 0,
					m: 0,
				}}
				onClick={(e: SyntheticEvent) => {
					handleOnClick(e);
				}}
			>
				{newUserName ? (
					<Avatar
						{...stringAvatar(newUserName ?? '', size)}
						src={
							newUserName === 'Rostislav'
								? '/img/users/ros.png'
								: newUserName === 'Aleksandra'
									? '/img/users/alex.png'
									: newUserName === 'Mikhail'
										? '/img/users/mikh.png'
										: newUserName === 'Peter'
											? '/img/users/peter.png'
											: newUserName === 'Teemu'
												? '/img/users/teemu.png'
												: newUserName === 'Robert'
													? '/img/users/robert.png'
													: newUserName === 'Nikolai'
														? '/img/users/nick.png'
														: newUserName === 'Andrii'
															? '/img/users/andrii.png'
															: newUserName === 'Victoria'
																? '/img/users/victoria.png'
																: newUserName === 'Oleg'
																	? '/img/users/oleg1.jpg'
																	: newUserName === 'Sasha'
																		? '/img/users/sasha.png'
																		: newUserName === 'Shirin'
																			? '/img/users/shirin.png'
																			: newUserName === 'Vilma'
																				? '/img/users/Vilma.png'
																				: newUserName === 'Aleksi'
																					? '/img/users/Aleksi.png'
																					: newUserName === 'Waltteri'
																						? '/img/users/Waltteri.png'
																						: undefined
						}
					/>
				) : (
					<AccountCircle
						sx={{
							color: COLORS.font_status,
							fontSize:
								size === 'xxs'
									? '1.2rem'
									: size === 'xs'
										? '1.4rem'
										: size === 'sm'
											? '1.8rem'
											: size === 'md'
												? 20
												: 48,
						}}
						onClick={() => {
							if (isAdmin) {
								navigate(PATHS.USER_MANAGEMENT_PAGE);
							}
						}}
					/>
				)}

				{newUserName?.trim() === '' ? (user?.email ?? 'Unknown') : newUserName}
			</Typography>
		</EasTooltip>
	);
};
